import request from '@/utils/request'

export function login(uername,password) {
    return request.post('/index/member/login',{
        account: uername,
        password: password
    });
}

export function register(uername,password,password2,reg_promo_code = '',code = '') {
    return request.post('/index/member/register',{
        account: uername,
        password: password,
        password2: password2,
        reg_promo_code: reg_promo_code,
        code: code
    });
}

export function resetpwd(account,password,code = '') {
    return request.post('/index/member/resetpwd',{
        account: account,
        password: password,
        code: code
    });
}

export function getUser() {
    return request.post('/index/member/getuser')
}

export function changePwd(old_password,password,password2) {
    return request.post('/index/member/change_pwd',{
        old_password: old_password,
        password: password,
        password2: password2
    });
}
/**
 * 卡密兑换
 * @param {*} kammi 
 * @returns 
 */
export function exCdkey(kammi) {
    return request.post('/index/member/ex_cdkey',{
        kammi: kammi
    });
}

/**
 * 分享页面信息接口
 * @returns 
 * all_count	会员总数
vip_count	已开通vip数
nvip_count	未开通vip数
over_count	vip过期数
tuiguang	推广奖励
tuiguang_tips	推广奖励描述
ok_count 推广成功人数
 */
export function shaoreDetail() {
    return request.post('/index/member/shaore_detail');
}
/**
 * 获取短信验证码
 * @param {*} kammi 
 * @returns 
 */
 export function sendCode(phone) {
    return request.post('/index/other/send_code',{
        phone: phone
    });
}


// WEBPACK FOOTER //
// ./src/api/user.js